var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardLayout',[_c('SettingsBody',{attrs:{"user":_vm.user}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }